export const MIN_LENGTH_ERROR = 'Minimum password length is 8 characters';
export const NO_MATCH_ERROR = "Passwords don't match";
export const INCORRECT_ERROR = 'Current password is incorrect';
